
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaArrowRightLong } from "react-icons/fa6";
import Colors from "../../utils/colors";


function HeaderSolutionsList(){
let navigate = useNavigate();
return(
<div>
<div className="dropdown-menu-h" style={{borderColor:Colors.bg2}}>
                <div className="row no-margin">
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", height:"100%", padding:"3em 2.5em", backgroundColor:Colors.bg2}}>
                            <div className="bold h2" style={{paddingBottom:"1em"}}>Solutions</div>
                            <div style={{color:Colors.black1, fontSize:"17px", lineHeight:1.6}}>
                                MonyTrack Business offers bespoke solutions tailored to enhance the efficiency of your financial operations.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>SOLUTIONS</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/collections")}>
                                <div className="dot"></div> <div className="m-item">Collections</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/payment-workflows")}>
                                <div className="dot"></div> <div className="m-item">Approval Based Payment Workflows</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/expense-management")}>
                                <div className="dot"></div> <div className="m-item">Expense Management</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/global-payments")}>
                                <div className="dot"></div> <div className="m-item">Global Payments</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/invoicing")}>
                                <div className="dot"></div> <div className="m-item">Invoice Automations</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/accounts-dashboard")}>
                                <div className="dot"></div> <div className="m-item">Accunts Dashboard</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>COMING SOON</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/collections-sdk")}>
                                <div className="dot"></div> <div className="m-item">Collection SDK</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/collection-pages")}>
                                <div className="dot"></div> <div className="m-item">Collection Pages</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/solutions/direct-debit")}>
                                <div className="dot"></div> <div className="m-item">Direct Debit</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                             
                        </div>
                    </div>
                </div>
        </div>
</div>
)
}
export default HeaderSolutionsList;